import React, { type FunctionComponent } from 'react'
import { Breadcrumb, Breadcrumbs } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/products/utils/domain/intl'
import { type DomainRouteName } from 'domains/products/routing/routes'
import { useDomainScopedPathname } from 'domains/products/utils/domain/routing'

interface ProductsBreadcrumbsProps {
  baseBreadcrumbs?: React.ReactChild
}

export const ProductsBreadcrumbs: FunctionComponent<ProductsBreadcrumbsProps> = ({
  children,
  baseBreadcrumbs,
}) => {
  // TODO: USE FLIPPER TO PROVIDE ROOT NODE
  const rootText = useDomainMessage('productsDomain.breadcrumbs.root')
  /**
   * TODO: this is linking outside of the domain and is an antipattern.
   * we should move the legacy search components into this domain, or
   * provide a better way to handle inter-domain linking
   */

  const searchPath = useDomainScopedPathname('search' as DomainRouteName)
  const resolvedBaseBreadcrumbs = baseBreadcrumbs || (
    <Breadcrumb path={searchPath}>{rootText}</Breadcrumb>
  )

  return (
    <Breadcrumbs>
      {resolvedBaseBreadcrumbs}
      {children}
    </Breadcrumbs>
  )
}
